import './silenceConsole'; // must stay first so it runs before other modules log
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n'; // Import i18n configuration

// Global fetch wrapper to prevent "Response body already used" errors
const originalFetch = window.fetch;
window.fetch = async function(...args) {
  const response = await originalFetch.apply(this, args);
  
  // Create a wrapper that handles the clone issue
  const originalJson = response.json.bind(response);
  const originalText = response.text.bind(response);
  const originalBlob = response.blob.bind(response);
  const originalArrayBuffer = response.arrayBuffer.bind(response);
  
  let bodyConsumed = false;
  let cachedBody = null;
  let bodyType = null;
  
  const consumeBody = async (method) => {
    if (bodyConsumed && cachedBody !== null) {
      return cachedBody;
    }
    
    try {
      const clone = response.clone();
      bodyConsumed = true;
      bodyType = method;
      
      if (method === 'json') {
        cachedBody = await clone.json();
      } else if (method === 'text') {
        cachedBody = await clone.text();
      } else if (method === 'blob') {
        cachedBody = await clone.blob();
      } else if (method === 'arrayBuffer') {
        cachedBody = await clone.arrayBuffer();
      }
      
      return cachedBody;
    } catch (e) {
      // If clone fails, try original
      if (method === 'json') {
        cachedBody = await originalJson();
      } else if (method === 'text') {
        cachedBody = await originalText();
      } else if (method === 'blob') {
        cachedBody = await originalBlob();
      } else if (method === 'arrayBuffer') {
        cachedBody = await originalArrayBuffer();
      }
      bodyConsumed = true;
      bodyType = method;
      return cachedBody;
    }
  };
  
  response.json = () => consumeBody('json');
  response.text = () => consumeBody('text');
  response.blob = () => consumeBody('blob');
  response.arrayBuffer = () => consumeBody('arrayBuffer');
  
  return response;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
